import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

import { Spinner } from 'components';

type ButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string | undefined;
};

const spinnerClassNameWhenCentered =
  'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2';

const Button: FC<ButtonProps> = ({
  type,
  className,
  onClick,
  disabled,
  isLoading,
  children,
  loadingText,
  ...restProps
}) => {
  const loadingTextDefined = loadingText && loadingText.length > 0;

  return (
    <button
      type={type}
      className={classNames(className, 'relative flex items-center justify-center')}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...restProps}
    >
      {isLoading && loadingTextDefined ? (
        <span className='flex items-center'>
          {loadingText}
          <span className='inline-block ml-2'>
            <Spinner />
          </span>
        </span>
      ) : (
        <span className={classNames(isLoading && 'invisible')}>{children}</span>
      )}

      {isLoading && !loadingTextDefined && (
        <span className={spinnerClassNameWhenCentered}>
          <Spinner />
        </span>
      )}
    </button>
  );
};

export default Button;
